import React from "react";

/**
 * Hover label above any avatar (or other small element): shows the person's
 * name (and an optional detail line). Used for task members and the Discord
 * presence strip so both behave the same.
 */
const NameTooltip = ({ name, detail, children, className = "" }) => (
  <span className={`group/name relative inline-flex hover:z-20 ${className}`} aria-label={detail ? `${name} · ${detail}` : name}>
    {children}
    <span
      role="tooltip"
      className="pointer-events-none absolute left-1/2 bottom-full mb-2 -translate-x-1/2 whitespace-nowrap rounded-lg border border-line2 bg-panel-solid px-2.5 py-1 text-[12px] font-medium text-ink shadow-modal opacity-0 translate-y-1 transition-all duration-150 group-hover/name:opacity-100 group-hover/name:translate-y-0 z-30"
    >
      {name || "Unknown"}
      {detail && <span className="block text-[11px] font-normal text-faint">{detail}</span>}
    </span>
  </span>
);

export default NameTooltip;
